import { get, omit } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import URI from 'urijs';
import { EXPERIMENT_USE_CUSTOM_ROUTER } from '@wix/communities-blog-experiments';
import getOuterUrl from '../../services/get-outer-url';
import { push } from '../../services/router-utils';
import { getLinkSectionInfo } from '../../services/section-route-utils';
import { isExperimentEnabled } from '@wix/communities-blog-client-common';
import { isSeo } from '../../selectors/view-mode-selectors';

const OMIT_PROPS = ['dispatch', 'titleFontClassName', 'tReady', 'lng', 'contentFontClassNameWithStyle'];

const isModifiedEvent = (event) => !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const InternalLink = ({
  push,
  to,
  onClick,
  children,
  renderInSeo,
  addHoverClasses,
  isSeo,
  useCustomRouter,
  customUrlData,
  ...props
}) => {
  const linkProps = omit(props, OMIT_PROPS);
  const { isInSameSection, navigateToSection, navigateToCustomRoute, sectionUrl } = getLinkSectionInfo(to);

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (event.defaultPrevented) {
      return;
    }

    if (!isModifiedEvent(event)) {
      event.preventDefault();
      event.stopPropagation();

      if (customUrlData) {
        return navigateToSection(to, { customizeTarget: { customUrlData } });
      }

      if (isInSameSection) {
        push(to);
      } else {
        return useCustomRouter ? navigateToCustomRoute(to) : navigateToSection(to);
      }
    }
  };

  let location;
  if (typeof to === 'object') {
    location = new URI(getOuterUrl(to.pathname, sectionUrl));
    location.search(to.search);
    location.hash(to.hash);
  } else {
    location = new URI(getOuterUrl(to, sectionUrl));
  }

  if (isSeo && !renderInSeo) {
    return <div {...linkProps}>{children}</div>;
  }

  return (
    <a
      target="_top"
      href={location.toString()}
      onClick={handleClick}
      {...linkProps}
      className={classNames(addHoverClasses && 'blog-link-hover-color', get(linkProps, 'className'))}
    >
      {children}
    </a>
  );
};

InternalLink.propTypes = {
  push: PropTypes.func,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
  renderInSeo: PropTypes.bool,
  addHoverClasses: PropTypes.bool,
  isSeo: PropTypes.bool,
  useCustomRouter: PropTypes.bool,
  customUrlData: PropTypes.object,
};

InternalLink.defaultProps = {
  renderInSeo: true,
  addHoverClasses: true,
};

const mapStateToProps = (state) => ({
  isSeo: isSeo(state),
  useCustomRouter: isExperimentEnabled(state, EXPERIMENT_USE_CUSTOM_ROUTER),
});

const mapDispatchToProps = (dispatch, { push: pushFn }) => bindActionCreators({ push: pushFn || push }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InternalLink);
